import React, { useEffect, useState } from "react";
import instance from "../../services/ApiServices";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../stores/cart";

function ProductDetail() {
  const { id } = useParams();
  const endpoint = `menuitems/${id}`;
  const [item, setItem] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();

  const handleMinusQty = () => {
    setQuantity(quantity - 1 < 1 ? 1 : quantity - 1);
  };

  const handlePlusQty = () => {
    setQuantity(quantity + 1);
  };

  const handleAddToCart = () => {
    dispatch(
      addToCart({
        productId: item.id,
        quantity: quantity,
      })
    );
  };

  useEffect(() => {
    // call Data from api
    instance.get(endpoint).then((res) => {
      const datas = res.data;
      setItem(datas);
    });
  }, [endpoint]);
  console.log(item);
  return (
    <div className="container pt-24">
      <div className="grid grid-cols-2 gap-5 mt-5">
        <div>
          <img
            src={item.image}
            alt=""
            className="w-full"
          />
        </div>
        <div className="flex flex-col gap-5">
          <h1 className="text-4xl uppercase font-bold">{item.name}</h1>
          <p className="font-bold text-3xl">${item.price}</p>
          <div className="flex gap-5">
            <div className="flex gap-2 justify-center items-center">
              <button
                className="bg-cyan-600 rounded-full w-6 h-6 text-white"
                onClick={handleMinusQty}
              >
                {" "}
                -{" "}
              </button>
              <span>{quantity}</span>
              <button
                onClick={handlePlusQty}
                className="bg-cyan-600 rounded-full w-6 h-6 text-white"
              >
                {" "}
                +{" "}
              </button>
            </div>
            <button
              onClick={handleAddToCart}
              className="bg-cyan-800 rounded-full 
               text-white px-5 py-2"
            >
              Add to Cart
            </button>
          </div>

          <p dangerouslySetInnerHTML={{ __html: item.description }} />
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
